//verificationMapper

export const verificationDetailsMapper = {
  "CIN Verification": {
    "title-card": {
      "title-subtext": "Company Name",
      label: "Corporate Profile",
      icon: "Group 1435.png",
      response_key: "company_name",
    },
    w_icons: [
      {
        title: "Birthdate",
        icon: "Path 1411.png",
        response_key: "",
      },
      {
        title: "Type",
        icon: "Path 1412.png",
        response_key: "",
      },
      {
        title: "Email",
        icon: "Path 1413.png",
        response_key: "email",
      },
      {
        title: "phone",
        icon: "Path 1414.png",
        response_key: "phone_number",
      },
    ],
    wo_icons: [
      {
        title: "CIN Number",
        response_key: "cin_number",
      },
      {
        title: "Authorized Capital",
        response_key: "authorized_capital",
      },
      {
        title: "Paid Up Capital",
        response_key: "paid_up_capital",
      },
      {
        title: "Company Status",
        response_key: "company_status",
      },
      {
        title: "Listed Status",
        response_key: "listed_status",
      },
    ],
  },
  "DIN Verification": {
    "title-card": {
      "title-subtext": "Full Name",
      label: "Personal Profile",
      icon: "1177568.png",
      response_key: "full_name",
    },
    w_icons: [
      {
        title: "Birthdate",
        icon: "Path 1411.png",
        response_key: "dob",
      },
      {
        title: "Email",
        icon: "Path 1413.png",
        response_key: "email",
      },
      {
        title: "Nationality",
        icon: "Path 2079.png",
        response_key: "nationality",
      },
    ],
    wo_icons: [
      {
        title: "Father's Name",
        response_key: "father_name",
      },
      {
        title: "DIN Number",
        response_key: "din_number",
      },
      {
        title: "PAN Number",
        response_key: "",
      },
    ],
  },
  "PAN Verification": {
    "title-card": {
      "title-subtext": "Full Name",
      label: "Personal Profile",
      icon: "1177568.png",
      response_key: "full_name",
    },
    w_icons: [
      {
        title: "Birthdate",
        icon: "Path 1411.png",
        response_key: "",
      },
      {
        title: "Father's Name",
        icon: "Path 1415.png",
        response_key: "",
      },
    ],
    wo_icons: [],
  },
  "GST Verification": {
    "title-card": {
      "title-subtext": "Company Name",
      label: "Corporate Profile",
      response_key: "business_name",
      icon: "Group 1435.png",
    },
    w_icons: [
      {
        title: "Birthdate",
        icon: "Path 1411.png",
        response_key: "date_of_registration",
      },
      {
        title: "Type",
        icon: "Path 1412.png",
        response_key: "taxpayer_type",
      },
    ],
    wo_icons: [
      {
        title: "PAN Number",
        response_key: "pan_no",
      },
      {
        title: "Company Status",
        response_key: "status",
      },
    ],
  },
};
